//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect, useRef } from 'react';
import { Container, Grid, Paper } from '@mui/material';
import FolderContent from './FolderContent/FolderContent';
import { selectFolderIsLoading } from '../../../redux/selectors/fileManagerSelectors';
import FileManagerUpload from '../FileManagerUpload';
import styled from '@emotion/styled';
import FileNavigationContainer from './FileNavigation/FileNavigationContainer';
import { useAppSelector } from '@/redux/hooks';
import { selectCanUploadFileManager } from '@/redux/selectors/authSelectors';

const FilesContainer = () => {
  const fileLoading = useAppSelector(selectFolderIsLoading);
  const fileGridRef = useRef<HTMLDivElement>(null);
  const canUpload = useAppSelector(selectCanUploadFileManager);

  useEffect(() => {
    if (!fileLoading && fileGridRef.current) {
      fileGridRef.current.scrollLeft = 9999;
    }
  }, [fileLoading]);

  return (
    <Container>
      <Paper sx={{ minHeight: 500, position: 'relative' }}>
        <FilesGrid container wrap="nowrap" ref={fileGridRef}>
          <FileNavigationContainer />
          <FolderContent />
          {canUpload && <FileManagerUpload />}
        </FilesGrid>
      </Paper>
    </Container>
  );
};

export default FilesContainer;

const FilesGrid = styled(Grid)`
  overflow-y: auto;
  min-height: 500px;
  & > nav {
    flex: 1 1 0;
    min-width: 300px;
    max-width: 500px;
    height: calc(100vh - 357px);
    min-height: 500px;
    overflow: auto;
    padding: 0;
    border-right: 1px solid ${(props) => props.theme.palette.action.disabledBackground};
    &:first-of-type {
      max-width: 20em;
      min-width: 20em;
    }
    &:last-of-type {
      min-width: 40vw;
      max-width: none;
      border: 0;
    }
  }
`;
